import store from '@/store'

export default {
  methods: {
    resizeFont (type, item) {
      if (item) {
        return [
          item,
          type + 'font-' + store.getters.size
        ]
      }
      else {
        [type + 'font-' + store.getters.size]
      }
    }
  }
}

